<template>
  <div class="list-errors">
    <navigator :items="items"></navigator>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="container-fluid">
              <div class="row filter-row">
                <div class="col-12">
                  <h5>Filtros</h5>
                </div>
                <div class="col-lg-2">
                  <div class="form-group">
                    <input
                      type="text"
                      v-model="filter.error"
                      placeholder="Descrição"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-lg-2">
                  <button
                    class="btn btn-primary"
                    v-on:click="filterTable('todas')"
                  >
                    Pesquisar
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-2">
                  <div class="form-group total">
                    <span v-on:click="filterTable('todas')"
                      >Total de erros: {{ total }}</span
                    >
                  </div>
                </div>
                <div class="col-lg-2">
                  <div class="form-group pendentes">
                    <span v-on:click="filterTable('Pendente')"
                      >Pendentes: {{ pendentes }} ({{
                        pendentesPercentage
                      }})</span
                    >
                  </div>
                </div>
                <div class="col-lg-2">
                  <div class="form-group concluidas">
                    <span v-on:click="filterTable('Conclúida')"
                      >Concluidas: {{ concluidas }} ({{
                        concluidasPercentage
                      }})</span
                    >
                  </div>
                </div>
                <div class="col-lg-2">
                  <div class="form-group canceladas">
                    <span v-on:click="filterTable('Cancelada')"
                      >Canceladas: {{ canceladas }} ({{
                        canceladasPercentage
                      }})</span
                    >
                  </div>
                </div>
                <div class="col-lg-2">
                  <div class="form-group execucao">
                    <span v-on:click="filterTable('Em Execução')"
                      >Em Execução: {{ execucao }} ({{
                        execucaoPercentage
                      }})</span
                    >
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <b-table
                    hover
                    :fields="fields"
                    :items="data"
                    :per-page="0"
                    :current-page="currentPage"
                    @row-clicked="selectItemTable"
                  >
                    <template v-slot:cell(user.name)="data">{{
                      data.value ? data.value : "-"
                    }}</template>
                  </b-table>
                  <b-pagination
                    class="float-right"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios";
import { bus } from "@/main";
export default {
  name: "list-errors",
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      pendentes: 0,
      total: 0,
      canceladas: 0,
      execucao: 0,
      concluidas: 0,
      pendentesPercentage: 0,
      concluidasPercentage: 0,
      canceladasPercentage: 0,
      execucaoPercentage: 0,
      rows: 0,
      items: [
        {
          text: "Erros e Melhorias",
          active: true,
        },
        {
          text: "Novo Erro ou Melhoria",
          route: "admin.error",
        },
      ],
      data: [],
      fields: [
        { key: "error", label: "Descrição" },
        { key: "status", label: "Status" },
      ],
      filter: {
        status: "",
        error: "",
      },
    };
  },
  mounted() {
    this.getPercentages();
    bus.$emit("changeLoading", true);
    this.getSavedData();
    this.providerData("todas");
  },
  watch: {
    currentPage: {
      handler: function (value) {
        this.providerData("todas");
      },
    },
  },
  methods: {
    filterTable(filtro) {
      this.currentPage = 1;
      this.providerData(filtro);
    },
    providerData(filtro) {
      axios
        .get(
          `${process.env.VUE_APP_API_HOST}/api/reported_error?${this.urlBuild(
            filtro
          )}`
        )
        .then((response) => {
          this.rows = response.data.total;
          this.data = response.data.data;
          bus.$emit("changeLoading", false);
        });
    },
    getSavedData: function () {
      if (
        localStorage.getItem("filters_search_erros") != null &&
        localStorage.getItem("filters_search_erros") != ""
      ) {
        var data = JSON.parse(localStorage.getItem("filters_search_erros"));
        this.filter = data.filter;
      }
    },
    saveDataOnStorage: function () {
      let filters = {
        filter: this.filter,
      };
      localStorage.setItem("filters_search_erros", JSON.stringify(filters));
    },
    urlBuild: function (filtro) {
      this.saveDataOnStorage()
      if (filtro === "todas") {
        this.filter.status = "";
      } else {
        this.filter.status = filtro;
      }
      let url =
        "page[number]=" +
        this.currentPage +
        "&page[size]=" +
        this.perPage +
        "&sort=order" +
        (this.filter.status != ""
          ? `&filter[status]=${this.filter.status}`
          : "") +
        (this.filter.error != "" ? `&filter[error]=${this.filter.error}` : "");

      return url;
    },
    selectItemTable: function (record, index) {
      this.$router.push({ name: "admin.error", params: { id: record.id } });
    },
    getPercentages: function () {
      let promise = axios.get(
        `${process.env.VUE_APP_API_HOST}/api/error_percentages`
      );

      promise
        .then((response) => {
          this.total = response.data.total;
          this.pendentes = response.data.pendentes;
          this.canceladas = response.data.canceladas;
          this.concluidas = response.data.concluidas;
          this.execucao = response.data.execucao;
          this.pendentesPercentage = response.data.pendentesPercentage;
          this.canceladasPercentage = response.data.canceladasPercentage;
          this.concluidasPercentage = response.data.concluidasPercentage;
          this.execucaoPercentage = response.data.execucaoPercentage;
        })
        .catch((error) => {
          bus.$emit("changeLoading", false);
          Swal.fire({
            title: "Ocorreu um erro.",
            icon: "error",
          });
        });
    },
  },
};
</script>

<style lang="scss">
.avatar {
  vertical-align: middle;
  width: 60px;
  height: auto;
  margin: 5px;
}
.total {
  color: black;
  cursor: pointer;
  text-decoration: underline;
}
.pendentes {
  color: red;
  cursor: pointer;
  text-decoration: underline;
}
.concluidas {
  color: green;
  text-decoration: underline;
  cursor: pointer;
}
.canceladas {
  color: orange;
  cursor: pointer;
  text-decoration: underline;
}
.execucao {
  color: blue;
  cursor: pointer;
  text-decoration: underline;
}
@import "@/styles/General.scss";
</style>
